import { render } from "./DestructionModal.vue?vue&type=template&id=8263e226"
import script from "./DestructionModal.vue?vue&type=script&lang=js"
export * from "./DestructionModal.vue?vue&type=script&lang=js"

import "./DestructionModal.vue?vue&type=style&index=0&id=8263e226&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__